export { Accordion } from "@mantine/core";
export type { AccordionProps } from "@mantine/core";
export { accordionOverrides } from "./Accordion.config";
